export interface IBatteryValues {
    internal: IFormattedBatteryValues;
    external: IFormattedBatteryValues;
}

export interface IStandardBatteryValues {
    voltage: number;
    percentage: number;
    isCharging: boolean;
}

export interface IFormattedBatteryValues extends IStandardBatteryValues {
    formattedVoltage: string;
    formattedPercentage: string;
}

export interface IVoltageValues {
    minVoltage: number;
    maxVoltage: number;
}

export interface IVoltageTable {
    voltage: number;
    percentage: number;
}

export type ComputedBatteryResponse = number;

export function formatBatteryValues(values: IStandardBatteryValues): IFormattedBatteryValues {
    function isFinite(value: number) {
        return (value !== null && value !== undefined && !isNaN(value));
    }

    return {
        ...values,
        formattedVoltage: `${isFinite(values.voltage) ? values.voltage.toFixed(2) : '-'} V`,
        formattedPercentage: `${isFinite(values.percentage) ? values.percentage.toFixed(2) : '-'}%`,
    }
}
